module.exports = __webpack_public_path__ + "img/reference53.f2396c5d.jpg";